import React, { Component } from 'react';
import Facets from './facets';
import Sort from './sort';
import { SearchResponse, SearchRequest } from '../../rpc/admin/search_pb';
import Adapter from './adapter';

interface SidebarProps {
    adapter: Adapter;
    response: SearchResponse
    request: SearchRequest;
}

interface SidebarState { }

class Sidebar extends Component<SidebarProps, SidebarState> {

    render() {
        let sort: JSX.Element = <></>;
        if (this.props.response?.getHitsList().length) {
            sort = <Sort adapter={this.props.adapter} selectedField={this.props.request!.getSortField()} direction={this.props.request!.getSortOrder()} />;
        }
        return (
            <div className="search-sidebar">
                {this.props.children}
                {sort}
                {this.props.response?.getAggregationsList() &&
                    this.props.response.getAggregationsList().map((agg) => {
                        if (agg.getAggregationsList().length) {
                            return (<Facets adapter={this.props.adapter} facet={agg} key={agg.getField()} />);
                        }
                        return undefined;
                    })
                }
            </div>
        );
    }
}

export default Sidebar;